var AbstractWS = require("./AbstractWS");

var HeartbeatWS = function (parent) {
  var self = this;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);
  self.failCount = 0;
  self.name = 'HeartbeatWS';
  self.status = ko.observable('ONLINE');
  self.timer = null;

  self.serviceURL = function () {
    return '/qless/api/v1/heartbeat';
  };


  self.doRequest = function () {
    self.conlog('Requesting heartbeat data');
    AbstractWS.prototype.doRequest.call(self);
  };

  self.failedHeartbeat = function () {
    self.status('TRYING')
    self.failCount = self.failCount + 1;

    self.conlog('Heartbeat timed out, total fail count: ' + self.failCount);

    if (self.failCount >= 5) {
      self.status('OFFLINE');
      self.reload();
    }
  };

  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    if (self.checkResponseForError(self, null, xmlData)) {
      self.failedHeartbeat();
    }
    else {
      self.status('ONLINE');
      self.conlog('...heartbeat complete');

      // If we failed at all, refresh all the queues
      if (self.failCount > 0) {
        self.failCount = 0;
        self.parent.poll();
        self.parent.selectedQueues().forEach(function (q) {
          try {
            q.updateAllSpots();
          }
          catch (e) {
            window.Sentry && window.Sentry.captureException(e);
          }
        });
      }
    }
  };


  self.reload = function () {

  };

  self.reset = function () {
    self.failCount = false;
    self.status('ONLINE');
    self.timer = null;
  };

  self.start = function () {
    self.reset();
    var randomWait = (Math.random() * 10000) + 20000;
    self.conlog('Starting heartbeat interval with delay of ' + randomWait);
    self.timer = window.setInterval(self.doRequest, randomWait);
  };

  self._errorHandler = self.failedHeartbeat;
}

HeartbeatWS.prototype = AbstractWS.prototype;
HeartbeatWS.prototype.constructor = HeartbeatWS;

module.exports = HeartbeatWS
